<sw-page class="topdata-llm-connect-llm-provider-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button
            variant="ghost"
            :disabled="isSyncing"
            @click="syncAllModels"
        >
            {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.buttonSyncAll') }}
        </sw-button>

        <sw-button variant="primary" @click="onAddProvider">
            {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.buttonAdd') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-llm-connect-llm-provider"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-active="{ item }">
                <sw-label v-if="item.active" variant="success" size="medium">
                    {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.activeYes') }}
                </sw-label>
                <sw-label v-else variant="danger" size="medium">
                    {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.activeNo') }}
                </sw-label>
            </template>

            <template #column-prefix="{ item }">
                <span>{{ labelFor(item.prefix) }}</span>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" :date-time-format="{ month: '2-digit', day: '2-digit' }" />
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditProvider(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onShowDeleteModal(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
                <sw-context-menu-item :disabled="isSyncing" @click="syncModels(item)">
                    {{ $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.syncMenuItem') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-confirm-modal
            v-if="showDeleteModal"
            :title="$tc('global.default.delete')"
            :text="deleteConfirmText"
            :confirmButtonVariant="'danger'"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />

        <topdata-llm-connect-llm-provider-form
            v-if="isFormInitialized"
            :entity="currentEntity"
            :repository="repository"
            :masked-secret="maskedSecret"
            :show-modal="activeModal"
            @save="onCloseModal"
            @cancel="onCloseModal"
        />
    </template>
</sw-page>
